<template>
    <div>
       <vs-table :data="data">
                <template slot="thead">
                    <vs-th>#</vs-th>
                    <vs-th>{{$t('description')|capitalize}}</vs-th>
                    <vs-th>{{$t('quantity')|capitalize}}</vs-th>
                    <vs-th>{{$t('unit_cost')|capitalize}}</vs-th>
                    <vs-th>{{$t('total')|capitalize}}</vs-th>
                    <vs-th>{{$t('actions')|capitalize}}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td >
                      {{indextr+1}}
                    </vs-td>
                    <vs-td >
                      {{tr.description}}
                    </vs-td>
                    <vs-td >
                      {{formatNumber(tr.quantity)}}
                    </vs-td>
                    <vs-td >
                      ${{formatNumber(tr.unit_cost,2)}}
                    </vs-td>
                    <vs-td >
                      ${{formatNumber(tr.unit_cost*tr.quantity,2)}}
                    </vs-td>
                    <vs-td >
                        <feather-icon
                            icon="TrashIcon"
                            style="color:'#cf1100'}"
                            svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                            @click="deleteItem(indextr)"
                        />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

                <vs-row vs-type="flex" vs-justify="flex-end">
                    <vs-col vs-w="2">
                        Subtotal:
                    </vs-col>
                    <vs-col vs-w="3">
                        ${{formatNumber(subtotal,2)}}
                    </vs-col>
                </vs-row>

                <vs-row vs-type="flex" vs-justify="flex-end">
                    <vs-col vs-w="2">
                        IVA:
                    </vs-col>
                    <vs-col vs-w="3">
                        ${{formatNumber(iva,2)}}
                    </vs-col>
                </vs-row>
                <vs-row vs-type="flex" vs-justify="flex-end">
                    <vs-col vs-w="2">
                        Total:
                    </vs-col>
                    <vs-col vs-w="3">
                        <b>${{formatNumber(total,2)}}</b>
                    </vs-col>
                </vs-row>
              
    </div>
</template>

<script>
export default {
    props:{
        data: {
            type: Array,
            default: () => []
        },
        subtotal: {
            type: Number,
            default: 0
        },
        iva: {
            type: Number,
            default: 0
        },
        total: {
            type: Number,
            default: 0
        }
    },
    methods: {
        deleteItem(index){
            this.$emit('deleteItem',index)
        }
    },
}
</script>